
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-tim-kinerja/penilai/perencanaan/daftar-ps/belum-diajukan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-tim-kinerja/penilai/perencanaan/daftar-ps/belum-diajukan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-tim-kinerja/penilai/perencanaan/daftar-ps/belum-diajukan"])
      });
    }
  